import React, { ComponentType } from 'react'

export const FormError: ComponentType = ({ children }) => {
  return <div className="invalid-feedback d-block">{children}</div>
}
